export default{
  methods:{
    uploadFile(file, onUploaded){
      return this.$store.dispatch('upload/upload_file',{
        file,
        callback:onUploaded
      })
    }
  }
}
